import { Brick, registerBrick, Query, ErrorFlow } from "olympe";

export default class FetchSQLConfig extends Brick {
  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {!Array<string>} modelTags
   * @param {function()} forwardEvent
   * @param {function(Object)} setSqlConfig
   * @param {function(*)} setErrorFlow
   */

  update($, [modelTags], [forwardEvent, setSqlConfig, setErrorFlow]) {
    try {
      const allResults = [];
      const tableResults = [];
      const sqlResults = [];

      const seenTableKeys = new Set();
      const seenSqlKeys = new Set();

      modelTags.forEach((modelTag) => {
        const results = Query.instancesOf(modelTag, false, "server")
          .executeFromCache()
          .map((el) => el?.toObject(true, false));

        results.forEach((res) => {
          const keys = Object.keys(res);
          const hasTableOrSchema = keys.some(
            (key) => key.startsWith("schema") || key.startsWith("table")
          );
          const hasSqlText = keys.some((key) => key.startsWith("sql text"));

          const commonKey = JSON.stringify(res);
          const isAlreadyIncluded =
            seenTableKeys.has(commonKey) || seenSqlKeys.has(commonKey);
          if (!isAlreadyIncluded) {
            allResults.push(res);
          }

          if (hasTableOrSchema) {
            const tableKey = [res["schema*"], res["table*"]].join("|");

            if (!seenTableKeys.has(tableKey)) {
              seenTableKeys.add(tableKey);
              tableResults.push(res);
            }
          }

          if (hasSqlText) {
            const sqlKey = [res["DB config id*"], res["sql text*"]].join("|");

            if (!seenSqlKeys.has(sqlKey)) {
              seenSqlKeys.add(sqlKey);
              sqlResults.push(res);
            }
          }
        });
      });

      const sqlTableRegex =
        /\b(?:FROM|JOIN|INTO|UPDATE|DELETE\s+FROM)\s+((?!#)[a-zA-Z0-9_.]+)/gi;
      const tableSet = new Set();

      allResults.forEach((curr) => {
        if (curr["table*"] && curr["DB config id*"] === "asapio_cm_write") {
          tableSet.add(`${curr["schema*"]}.${curr["table*"]}`);
        }

        // const sqlText = curr["sql text*"];
        // if (typeof sqlText === "string") {
        //   let match;
        //   while ((match = sqlTableRegex.exec(sqlText)) !== null) {
        //     const tableRef = match[1];
        //     tableSet.add(tableRef);
        //   }
        // }
      });

      console.log("Unique combined paramConfigs:", allResults);
      console.log("Table results:", tableResults);
      console.log("SQL results:", sqlResults);
      console.log(
        "Tables extracted:",
        Array.from(tableSet).filter((t) =>
          /^[a-zA-Z0-9_]+\.[a-zA-Z0-9_]+$/.test(t)
        )
      );

      setSqlConfig({
        allResults,
        rawConfigs: tableResults,
        storedQueries: sqlResults,
      });

      forwardEvent();
    } catch (error) {
      console.error("Error during execution:", error);
      setErrorFlow(ErrorFlow.create(`Error: ${error.message || error}`));
    }
  }
}

registerBrick("0197a63b33eff0e42d5e", FetchSQLConfig);
